'use client'

import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import styles from './WalletReceive.module.css'
import copy from 'copy-to-clipboard'
import CopyIcon from '@/icons/copy-no-view'
import QRCode from 'react-qr-code'
import CopyButton from '@/components/copy-button'
import Wallet from '@/utils/wallet'
import Address from '@/components/address'
import Button from '@/components/button'
import QRCodeIcon from '@/icons/qr-code'
import { NETWORK } from '@/utils/constants'
import Link from 'next/link'
import { ArrowDownUp, ArrowUpRight } from 'lucide-react'

const WalletReceive: FC<{
	handleModalClose?: () => void
}> = (props): ReactElement => {
	const copiedRef = React.useRef(false)
	const address = Wallet.getTaprootAddress()

	const _handleCopy = React.useCallback(() => {
		copy(address)
		copiedRef.current = true
		setTimeout(() => (copiedRef.current = false), 1500)
	}, [address])

	return (
		<div className={styles.root}>
			<div className={styles.header}>
				<div className={styles.sendRcvIconContainer}>
					<QRCodeIcon fill="#7F56D9" width={17} height={20} />
				</div>
			</div>
			<div className={classNames(styles.receive, 'text-lg', 'semibold')}>Receive</div>
			<div className={classNames(styles.description, 'text-sm', 'regular')}>
				Only send {NETWORK} and Ordinals NFTs to this wallet.
			</div>
			{NETWORK === 'BTC' && <Link href="/swap" onClick={props.handleModalClose} className={styles.swapOption}>
				<ArrowDownUp size={20} /><span><strong>Swap crypto to BTC</strong><small>Deposit from another coin or network</small></span><ArrowUpRight size={17} />
			</Link>}
			<div className={styles.qrContainer}>
				<div className={styles.qrCode}>
					<QRCode
						size={256}
						style={{ height: 'auto', margin: '0 auto', width: '100%' }}
						value={address}
						viewBox="0 0 256 256"
					/>
				</div>
			</div>
			<Address className={classNames(styles.address, 'text-xs')} />
			<div className={styles.copyButtonContainer}>
				<CopyIcon width={18} height={18} />
				<CopyButton
					className={classNames(styles.copyButton, 'text-sm', 'regulat')}
					label="Copy to clipboard"
					value={address}
				/>
			</div>
			<Button
				background="transparent"
				className={classNames(styles.cancelButton, 'text-md', 'semibold')}
				onClick={props.handleModalClose}
			>
				Cancel
			</Button>
		</div>
	)
}

export default WalletReceive
